module.exports = __webpack_public_path__ + "img/spazi_5.eee0027c.webp";